<script lang="ts">
  import Menu from "../molecules/Menu.svelte";
  import AnimationContainer from "../atoms/AnimationContainer.svelte";
  import { decodeEntities } from "../../helpers/helperMethods";

  interface Props {
    image?: string;
    errorBanner: string | undefined;
    campaign: string;
    header?: import("svelte").Snippet;
    breadcrumbs?: import("svelte").Snippet;
    children?: import("svelte").Snippet;
    contact?: import("svelte").Snippet;
  }

  let {
    image = undefined,
    errorBanner = $bindable(),
    campaign,
    header,
    breadcrumbs,
    children,
    contact,
  }: Props = $props();

  errorBanner = decodeEntities(errorBanner);
</script>

<div
  class="min-h-3/6 md:min-h-4/6 w-full flex flex-col items-center overflow-x-hidden purchase bg-Neutral110 mb-8"
>
  {@render header?.()}
  <Menu {campaign} />
  <main class=" h-full w-full flex justify-center">
    <div class="w-full ll lg:mx-16 lg:max-w-grid flex justify-center">
      {#if image}
        <div class="hidden lg:block flex-1 mr-8 z-10 h-full">
          <div
            class="w-full h-full mb-8 z-10 bg-Neutral400"
            style="background: url({image}) no-repeat center center; background-size: cover; height:730px"
          ></div>
        </div>
      {/if}
      <div class="flex-1 flex align-center flex-col sm:px-0 max-w-content {image ? 'lg:ml-8' : ''}">
        <div
          class="w-full flex items-center flex-row-reverse sm:flex-col justify-between flex-shrink-0"
        >
          {#if errorBanner}
            {@html errorBanner}
          {/if}
          {@render breadcrumbs?.()}
        </div>
        <AnimationContainer class="px-3 sm:p-0 pb-6 sm:pb-0">
          {@render children?.()}
        </AnimationContainer>
      </div>
    </div>
    {@render contact?.()}
  </main>
</div>
